import { Map } from "immutable";

import StudentAssignment from "../../models/StudentAssignment";
import { AssignmentMetaType } from "../../models/StudentAssignmentsMetaState";
import StudentAssignmentsState from "../../models/StudentAssignmentsState";
import * as studentAssignmentsSelectors from "./assignments/studentAssignments";

export function getAssignments(
  state: StudentAssignmentsState
): Map<string, StudentAssignment> {
  return state.assignments;
}

export function getMeta(state: StudentAssignmentsState): AssignmentMetaType {
  return state.meta;
}

export function getAssignmentQuestionStat(
  state: StudentAssignmentsState,
  assignmentId: string,
  questionId: string
) {
  const assignments = getAssignments(state);

  return studentAssignmentsSelectors.getAssignmentQuestionStat(
    assignments,
    assignmentId,
    questionId
  );
}
